import store from '@/store'
import { defaultLocale } from '@/router/router'

// @TODO: Check if this is still needed
export function isRedirectRequired(to) {
  const isAuthenticated = store.getters.isAuthenticated || false
  const requiresAuthentication = to.matched.some(
    record => record.meta.requiresAuth
  )
  return !isAuthenticated && requiresAuthentication
}

export function redirectToDashboard(to) {
  const isAuthenticated = store.getters.isAuthenticated || false
  const isLoginOrDefaultPage = ['homepage', 'defaultSignIn'].includes(to.name)
  return isAuthenticated && isLoginOrDefaultPage
}

export function getLocalLocale() {
  return store.getters.locale
    ? store.getters.locale.toLowerCase()
    : setLocalLocale(defaultLocale)
}

export function setLocalLocale(locale) {
  store.dispatch('setLocale', locale)
  return locale
}
